import { useEffect, useState } from "react";
import { Download, AlertTriangle, FileSpreadsheet } from "lucide-react";
import { apdApi } from "@/api";
import { useLang, fmtMoney } from "@/i18n";

export const ApdCard = ({ year, month }) => {
  const { t } = useLang();
  const [s, setS] = useState(null);
  useEffect(() => { apdApi.summary(year, month).then(setS).catch(() => setS(null)); }, [year, month]);
  if (!s) return null;

  const warn = (w) => {
    if (w.startsWith("employee:")) { const [, name, fields] = w.split(":"); return `${t("warn_employee")} ${name}: ${fields}`; }
    return t(`warn_${w}`);
  };

  return (
    <div className="erp-card p-5 space-y-3" data-testid="apd-card">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <FileSpreadsheet size={18} className="text-blue-700" />
          <div>
            <h3 className="font-heading font-semibold">{t("apd_title")} · {year}-{String(month).padStart(2, "0")}</h3>
            <p className="text-xs text-slate-500">{t("apd_hint")}</p>
          </div>
        </div>
        <a href={s.payslips ? apdApi.fileUrl(year, month) : undefined} download data-testid="apd-download-link"
          className={`h-9 px-4 inline-flex items-center gap-2 rounded-md text-sm font-medium text-white ${s.payslips ? "bg-blue-800 hover:bg-blue-700" : "bg-slate-300 pointer-events-none"}`}>
          <Download size={14} />{t("apd_download")}
        </a>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 font-mono text-sm">
        <div><div className="font-body text-xs text-slate-500">{t("employees")}</div><div data-testid="apd-employees">{s.employees}</div></div>
        <div><div className="font-body text-xs text-slate-500">{t("insurance_days")}</div><div data-testid="apd-days">{s.days}</div></div>
        <div><div className="font-body text-xs text-slate-500">{t("gross")}</div><div>{fmtMoney(s.earnings)}</div></div>
        <div><div className="font-body text-xs text-slate-500">ΕΦΚΑ</div><div>{fmtMoney(s.contributions)}</div></div>
      </div>
      {s.warnings.length > 0 && (
        <div className="text-xs text-amber-800 dark:text-amber-300 bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800 rounded p-3 space-y-0.5" data-testid="apd-warnings">
          <div className="font-semibold inline-flex items-center gap-1"><AlertTriangle size={12} />{t("apd_warnings")}</div>
          {s.warnings.map((w) => <div key={w}>· {warn(w)}</div>)}
        </div>
      )}
    </div>
  );
};
